import { ClientOnly } from 'remix-utils/client-only'

type Props = {
  id: string
}

export default function Dom({ id }: Props) {
  return <ClientOnly>{() => <div id={id} />}</ClientOnly>
}

Dom.scheme = {
  render: 'Dom',
  attributes: {
    id: { type: String, required: true }
  }
}
